import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import EATableHead from "./tableComponents/EATableHead";
import EATableBody from "./tableComponents/EATableBody";
import EATablePagination from "./tableComponents/EATablePagination";
import "../styles/components/table.css";
import {ASC, DESC} from "../utils/ArrayUtils";
import LoadingPlaceholder from "./LoadingPlaceholder";

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
    container: {
        maxHeight: "100%",
    },
});

/**
 * Komponente zur Darstellung einer Tabelle mit Paginierung, falls entsprechend viele Ergebnisse angezeigt werden müssen
 * @param id
 * @param columns Ein Array von column Objekten => ColumnUtils können bei der Erstellung hilfreich sein
 * @param initialSortColumn
 * @param data Ein Array von darzustellenden Daten. Der jeweilige ObjektKey muss der id der entsprechenden Spalte entsprechen
 * @param loading boolean, welcher true sein sollte, wenn die Daten aktuell vom Backend geladen werden
 * @param style
 * @param initRowsPerPage Die standardmäßig pro Seite dargestellten Einträge (per default 10)
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function EAPaginatedTable({
                              id,
                              columns,
                              data,
                              loading,
                              style,
                              rowsPerPage: initRowsPerPage = 10,
                              onDoubleClick = null,
                              onAltDoubleClick = null,
                              pageInfo,
                              setPageInfo,
                              ...rest
                          }) {
    const classes = useStyles();

    const handleChangePage = (event, newPage) => {
        setPageInfo({...pageInfo, page: newPage});
    };

    const handleChangeRowsPerPage = (event) => {
        setPageInfo({...pageInfo, pageSize: parseInt(event.target.value), page: 0});
    };

    function handleRequestSort(event, property) {
        const isAsc = pageInfo.sortProperty === property && pageInfo.sortDirection === ASC;
        setPageInfo({
            ...pageInfo, sortProperty: property, sortDirection: isAsc ? DESC : ASC
        });
    }


    return (
        <Paper className={classes.root} style={style}>
            {loading && <LoadingPlaceholder/>}
            {!loading && data?.page && initRowsPerPage < data?.totalCount && (
                <EATablePagination
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    length={data.totalCount}
                    page={pageInfo?.page}
                    rowsPerPage={pageInfo?.pageSize}
                />
            )}
            <TableContainer className={classes.container}>
                <Table stickyHeader size="small" {...rest}>
                    <EATableHead id={id + "-head"}
                                 order={pageInfo?.sortDirection}
                                 orderBy={pageInfo?.sortProperty}
                                 onRequestSort={handleRequestSort}
                                 headCells={columns}/>
                    {!loading && (
                        <EATableBody
                            id={id + "-body"}
                            columns={columns}
                            data={data?.page}
                            visibleRows={data?.page ? data.page : []}
                            onDoubleClick={onDoubleClick}
                            onAltDoubleClick={onAltDoubleClick}
                        />
                    )}
                </Table>
            </TableContainer>
        </Paper>
    );
}

export default EAPaginatedTable;
